import { render, staticRenderFns } from "./MainHistorySingo2.vue?vue&type=template&id=03027b40&scoped=true"
import script from "./MainHistorySingo2.vue?vue&type=script&lang=js"
export * from "./MainHistorySingo2.vue?vue&type=script&lang=js"
import style0 from "./MainHistorySingo2.vue?vue&type=style&index=0&id=03027b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03027b40",
  null
  
)

export default component.exports